export const CREATE_CAMPAIGN = 'create-campaign';
export const MANAGE = 'manage-campaigns';
export const LOGIN = 'login';
export const HOME = 'home';
